import { electronicTemplateApi } from '../../api';
import { ElectronicDocumentTemplateForm } from '../../types/documentTemplate/ElectronicDocumentTemplateTypes';

const ElectronicDocumentTemplateService = {
    getAllTemplates: async () => {
        const response = await electronicTemplateApi.fetchAll();
        return response.data;
    },

    /**
     * Obtiene una plantilla específica por ID.
     * GET /api/electronic-document-templates/{id}
     */
    getTemplateById: async (id: number) => {
        const response = await electronicTemplateApi.fetchById(id);
        return response.data;
    },

    /**
 * Obtiene los datos completos de una plantilla para edición.
 * GET /api/electronic-document-templates/edit/{id}
 */
    getTemplateForEdit: async (id: number) => {
        const response = await electronicTemplateApi.fetchCustom(`/edit/${id}`);
        return response.data;
    },


    previewTemplateById: async (id: number): Promise<Blob> => {
        const url = `/preview-by-id/${id}`;
        const response = await electronicTemplateApi.fetchBlob(url); // esto retorna AxiosResponse
        return response.data; // 👈 aquí debes retornar solo el blob, no todo el objeto de respuesta
    },

    /**
     * Crea una nueva plantilla de documento electrónico.
     * POST /api/electronic-document-templates
     */
    createTemplate: async (data: ElectronicDocumentTemplateForm, file?: File) => {
        const response = await electronicTemplateApi.postFormData(data, file);
        return response.data;
    },

    /**
     * Actualiza una plantilla de documento electrónico.
     * PUT /api/electronic-document-templates/{id}
     */
    updateTemplate: async (id: number, data: ElectronicDocumentTemplateForm, file?: File) => {
        const response = await electronicTemplateApi.putFormData(id, data, file);
        return response.data;
    },

    /**
     * Activa o desactiva una plantilla.
     * PUT /api/electronic-document-templates/{id}/status
     */
    toggleStatus: async (id: number) => {
        const response = await electronicTemplateApi.patchCustom(`${id}/toggle`);
        return response.data;
    },
};

export default ElectronicDocumentTemplateService;
